import { formComponents as fc } from "@/components/form";
import { Label } from "@/components/ui/label";
import { useClinicianOptions } from "@/features/auth/api/cliniciansByOrganisationQuery";
import InviteForm from "@/features/invite/components/InviteForm";

interface Props {
	organisationId: string;
	labels?: {
		name?: string;
		description?: string;
		educatedBy?: string;
	};
	descriptions?: {
		name?: string;
		description?: string;
		educatedBy?: string;
	};
}

const EducationFormFields = ({
	organisationId,
	labels = {
		name: "Education Name",
		description: "Description",
		educatedBy: "Educated By",
	},
	descriptions = {
		name: "e.g., Pain Management Workshop, Post-Surgery Care Instructions",
		description:
			"Describe what was discussed or taught during this education session",
		educatedBy: "The clinician who provided the education",
	},
}: Props) => {
	const clinicianOptions = useClinicianOptions(organisationId ?? "");

	return (
		<>
			<fc.Input
				label={labels.name}
				name="education_name"
				placeholder={descriptions.name}
			/>

			<fc.Textarea
				label={labels.description}
				name="education_description"
				placeholder={descriptions.description}
				className="min-h-[100px]"
			/>

			<fc.ComboBox
				name="educated_by"
				label={labels.educatedBy}
				description={descriptions.educatedBy}
				options={clinicianOptions}
				clearable={true}
				addOption={<InviteForm />}
			/>
		</>
	);
};

export default EducationFormFields;
